import {SUCCESS} from "../../../../constants/action-postfix";
import {PHONEBOOK_REQUEST} from "../phonebookReducer";


const initialState = [];

export const phonebookListReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${PHONEBOOK_REQUEST}${SUCCESS}`:
            return action.payload;

        default:
            return state;
    }
};